import { observer } from "mobx-react"

import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { TopupPaymentResponse } from "@src/shared/api/generated"
import { dateTimeFormat } from "@src/shared/date"
import css from "./depositListItem.module.css"

type Props = {
  item: TopupPaymentResponse
}
export const DepositListItem = observer(({ item }: Props) => {
  const { amount, detected_at, network, status, symbol } = item
  const currencies = GlobalCurrenciesCollection()
  const currency = currencies.getBySymbolNetwork({
    network: item.network as string,
    symbol: item.symbol as string,
  })

  return (
    <div className={css.container}>
      <div className={css.wrapper}>
        <span className={css.top}>{currency?.symbol_alias ?? symbol}</span>
        <span className={css.bottom}>
          {dateTimeFormat(detected_at as string)}
        </span>
      </div>
      <div className={css.wrapper}>
        <span className={css.top}>{amount}</span>
        <span className={css.bottom}>{status}</span>
      </div>
    </div>
  )
})
